<template>
  <div v-loading="loading">
    <el-form ref="form" :model="form" label-width="0px" @submit.prevent="onSubmit" style="margin: 20px; width: 80%; min-width: 600px">
      <el-form-item v-for="(item, index) in form.targetPosition">
        <table>
          <tr>
            <td>Position @ {{ index + -10 }}°F</td>
            <td><el-input v-model="form.targetPosition[index]"></el-input></td>
          </tr>
        </table>
      </el-form-item>
      <el-form-item style="margin-top: 10px">
        <el-button type="primary" style="margin-top: 10px" @click="saveDataToPanel">Save to Panel</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Axios from "axios"
import echarts from "echarts"
import IOService from "@/api/io.service"
import SettingsService from "@/api/settings.service"
import constants from "@/common/constants/system"

export default {
  data() {
    return {
      loading: false,
      form: {
        enabled: false,
        targetPosition: [
          "10",
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10,
          10
        ]
      },
      editDialog: {
        visible: false,
        value: "",
        title: "",
        currentValue: ""
      },
      user: this.$session.get("User")
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    verifySettings() {
      for (let element of this.form.targetPosition) {
        if (isNaN(parseInt(element)) || parseInt(element) < 0 || parseInt(element) > 100) {
          const h = this.$createElement
          this.$notify({
            title: "Setpoint",
            message: "Value not valid.  Value should be between 0 and 100",
            type: "error"
          })
          return false
        }
      }
      return true
    },
    formatArrayForPanel(arrayToFormat) {
      var arrayForPanel = arrayToFormat
      for (var idx = 0; idx < arrayForPanel.length; idx++) {
        arrayForPanel[idx] = arrayForPanel[idx] + ""
      }
      return arrayForPanel
    },
    saveDataToPanel() {
      if (!this.verifySettings()) return true
      this.loading = true
      Axios.all([SettingsService.changeSetting(this.user.activeZone, "Settings.ProgramMode.Value", JSON.stringify(this.formatArrayForPanel(this.form.targetPosition)))])
        .then(
          Axios.spread((valueResponse) => {
            //The system should update in 10 seconds.
            this.loading = false
            if (valueResponse.data.result != "success") {
              const h = this.$createElement
              this.$notify({
                title: "Program Mode",
                message: "Error trying to save data to panel",
                type: "error"
              })
            } else {
              this.$notify({
                title: "Program Mode",
                message: "Settings Saved to Panel",
                type: "info"
              })
              this.getData()
            }
          })
        )
        .catch(() => {
          this.loading = false
          const h = this.$createElement
          this.$notify({
            title: "Program Mode",
            message: "Error trying to save data to panel",
            type: "error"
          })
        })
    },

    getData() {
      Axios.all([IOService.getSettings(this.user.activeZone)]).then(
        Axios.spread((settingsResponse) => {
          console.log(settingsResponse.data)
          //We change all the values into a string
          this.form.targetPosition = settingsResponse.data.programMode.value
        })
      )
    }
  }
}
</script>

<style scoped>
.chart-container {
  width: 100%;
  float: left;
}
/*.chart div {
        height: 400px;
        float: left;
    }*/

.el-col {
  padding: 30px 20px;
}
</style>



// WEBPACK FOOTER //
// ProgramMode.vue?87e52302